import { render, staticRenderFns } from "./Venta_Detallada.vue?vue&type=template&id=17909c1c"
import script from "./Venta_Detallada.vue?vue&type=script&lang=js"
export * from "./Venta_Detallada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports